import { useEffect } from 'react'
import { useStore } from '@/models'
import { Doc } from '@ppwr/convex/_generated/dataModel'
import {
  isCelebrationMessage,
  parseCelebrationMessage,
  createRemoteCelebration
} from '@/screens/new-design/hooks/useCelebration'
import { useNewMessages } from './useNewMessages'
import { useGameState } from '../../screens/GameContainer/useGameState'

type ConvexChatMessage = Doc<'chatMessages'>

/**
 * Hook to detect and trigger celebration messages from a stream of chat messages
 * Tracks new messages and automatically triggers celebrations for celebration-formatted messages
 * To celebrate only new celebrations from now on, the default start time is now.
 */
export function useCelebrationMessages(messages: ConvexChatMessage[] | undefined, startTime = Date.now()) {
  const {
    communication: { handleCelebrations }
  } = useStore()
  const { myPlayer, game } = useGameState()

  // Use timestamp-based filtering to get only new messages (ignore all pre-existing!)
  const newMessages = useNewMessages(messages, game?._id, startTime)

  useEffect(() => {
    if (newMessages.length === 0) return

    // Process celebrations from new messages
    newMessages.forEach((msg) => {
      if (msg.chatKind === 'engine' && isCelebrationMessage(msg.message)) {
        const emoji = parseCelebrationMessage(msg.message)
        // Don't send to self if player is the sender
        if (emoji && myPlayer?.userId !== msg.userId) {
          // Create and trigger celebration using the remote celebration helper
          const celebrationMessage = createRemoteCelebration(emoji, msg.userId || 'me', undefined, msg._id)
          handleCelebrations(celebrationMessage)
        }
      }
    })
  }, [newMessages, handleCelebrations, myPlayer?.userId])
}
